import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3590e520"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-page" }
const _hoisted_2 = { class: "settings-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "settings-eyebrow" }, "Seu app financeiro"),
  /*#__PURE__*/_createElementVNode("h1", null, "Configurações"),
  /*#__PURE__*/_createElementVNode("p", null, "Ajuste seus dados pessoais e gerencie seu plano de casal.")
], -1))
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  class: "settings-hero",
  "aria-labelledby": "settings-overview-title"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "settings-hero__label" }, "Resumo do perfil", -1))
const _hoisted_7 = { id: "settings-overview-title" }
const _hoisted_8 = {
  class: "settings-hero__stats",
  "aria-label": "Resumo das configurações"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-users",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = { class: "settings-grid" }
const _hoisted_11 = {
  class: "settings-panel account-panel",
  "aria-labelledby": "account-title"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"settings-panel__heading\" data-v-3590e520><div data-v-3590e520><span class=\"settings-eyebrow\" data-v-3590e520>Perfil</span><h2 id=\"account-title\" data-v-3590e520>Dados pessoais</h2><p data-v-3590e520>Informações usadas para identificar você dentro do app.</p></div><span class=\"settings-panel__icon\" data-v-3590e520><i class=\"ph ph-user-circle\" aria-hidden=\"true\" data-v-3590e520></i></span></div>", 1)
const _hoisted_13 = { class: "settings-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nome completo", -1))
const _hoisted_15 = { class: "settings-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "E-mail", -1))
const _hoisted_17 = { class: "settings-field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Telefone", -1))
const _hoisted_19 = { class: "settings-field settings-field--wide" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "company-token-label" }, "Código de amizade", -1))
const _hoisted_21 = { class: "token-box" }
const _hoisted_22 = { "aria-labelledby": "company-token-label" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-copy",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "profile-confirm-modal__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_27 = { class: "profile-confirm-modal__header" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "settings-eyebrow" }, "Confirmação de segurança"),
  /*#__PURE__*/_createElementVNode("h2", { id: "save-confirmation-title" }, "Confirme sua senha")
], -1))
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Digite sua senha atual para confirmar as alterações no nome e telefone.", -1))
const _hoisted_33 = { class: "settings-field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Senha atual", -1))
const _hoisted_35 = {
  key: 0,
  class: "settings-feedback settings-feedback--error"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-warning-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_37 = { class: "profile-confirm-modal__actions" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CoupleSettings = _resolveComponent("CoupleSettings")!
  const _component_UsersList = _resolveComponent("UsersList")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "refresh-button",
        type: "button",
        disabled: _ctx.refreshing,
        "aria-label": "Atualizar configurações",
        title: "Atualizar configurações",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadPageData && _ctx.loadPageData(...args)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["ph ph-arrow-clockwise", { 'is-spinning': _ctx.refreshing }]),
          "aria-hidden": "true"
        }, null, 2)
      ], 8, _hoisted_4)
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.companyName), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.companyEmail), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.usersCountLabel), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("section", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("form", {
          class: "settings-form",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.requestSaveConfirmation && _ctx.requestSaveConfirmation(...args)), ["prevent"]))
        }, [
          _createElementVNode("label", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.configurationForm.name) = $event)),
              type: "text",
              class: "form-control",
              autocomplete: "name",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.configurationForm.name]
            ])
          ]),
          _createElementVNode("label", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.configurationForm.email) = $event)),
              type: "email",
              class: "form-control",
              autocomplete: "email",
              "aria-disabled": "true",
              disabled: ""
            }, null, 512), [
              [_vModelText, _ctx.configurationForm.email]
            ])
          ]),
          _createElementVNode("label", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.configurationForm.phone) = $event)),
              type: "tel",
              inputmode: "tel",
              autocomplete: "tel",
              maxlength: "19",
              class: "form-control",
              placeholder: "(11) 99999-9999",
              required: "",
              onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.maskPhone && _ctx.maskPhone(...args)))
            }, null, 544), [
              [_vModelText, _ctx.configurationForm.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("code", _hoisted_22, _toDisplayString(_ctx.companyToken || 'Token ainda não disponível'), 1),
              _createElementVNode("button", {
                type: "button",
                disabled: !_ctx.companyToken,
                "aria-label": "Copiar código de amizade",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.copyCompanyToken && _ctx.copyCompanyToken(...args)))
              }, [
                _hoisted_24,
                _createTextVNode(" " + _toDisplayString(_ctx.copyTokenFeedback || 'Copiar'), 1)
              ], 8, _hoisted_23)
            ])
          ]),
          (_ctx.configurationFeedback.message)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["settings-feedback", _ctx.configurationFeedback.error ? 'settings-feedback--error' : 'settings-feedback--success'])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.configurationFeedback.error ? 'ph ph-warning-circle' : 'ph ph-check-circle'),
                  "aria-hidden": "true"
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(_ctx.configurationFeedback.message), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            class: "save-settings-button",
            disabled: _ctx.savingConfigurations
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.savingConfigurations ? 'Salvando...' : 'Salvar alterações'), 1),
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.savingConfigurations ? 'ph ph-spinner-gap is-spinning' : 'ph ph-arrow-right'),
              "aria-hidden": "true"
            }, null, 2)
          ], 8, _hoisted_25)
        ], 32)
      ])
    ]),
    _createVNode(_component_CoupleSettings),
    _createVNode(_component_UsersList),
    (_ctx.showSaveConfirmation)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "saveConfirmationModal",
          class: "profile-confirm-modal",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "save-confirmation-title",
          tabindex: "-1",
          onKeydown: _cache[12] || (_cache[12] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeSaveConfirmation && _ctx.closeSaveConfirmation(...args)), ["esc"]))
        }, [
          _createElementVNode("button", {
            class: "profile-confirm-modal__backdrop",
            type: "button",
            "aria-label": "Fechar confirmação",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeSaveConfirmation && _ctx.closeSaveConfirmation(...args)))
          }),
          _createElementVNode("form", {
            class: "profile-confirm-modal__content",
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveConfigurations && _ctx.saveConfigurations(...args)), ["prevent"]))
          }, [
            _hoisted_26,
            _createElementVNode("header", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("button", {
                type: "button",
                "aria-label": "Fechar",
                disabled: _ctx.savingConfigurations,
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeSaveConfirmation && _ctx.closeSaveConfirmation(...args)))
              }, _hoisted_31, 8, _hoisted_29)
            ]),
            _hoisted_32,
            _createElementVNode("label", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createElementVNode("input", {
                ref: "confirmationPasswordInput",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.confirmationPassword) = $event)),
                type: "password",
                class: "form-control",
                autocomplete: "current-password",
                placeholder: "Digite sua senha",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.confirmationPassword]
              ])
            ]),
            (_ctx.confirmationError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("span", null, _toDisplayString(_ctx.confirmationError), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                type: "button",
                class: "profile-confirm-modal__cancel",
                disabled: _ctx.savingConfigurations,
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeSaveConfirmation && _ctx.closeSaveConfirmation(...args)))
              }, " Cancelar ", 8, _hoisted_38),
              _createElementVNode("button", {
                type: "submit",
                class: "profile-confirm-modal__confirm",
                disabled: _ctx.savingConfigurations
              }, _toDisplayString(_ctx.savingConfigurations ? 'Confirmando...' : 'Confirmar e salvar'), 9, _hoisted_39)
            ])
          ], 32)
        ], 544))
      : _createCommentVNode("", true)
  ]))
}